import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import ReactToPrint from 'react-to-print';
import Button from '../../../../components/base/Button/Button.component';
import { printBukuInduk } from '../../../../utils/print.util';

function onClickPrint(header, content, footer) {
  printBukuInduk(header, content, footer);
}

class ComponentToPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      journal: {},
    };
    this.onGetDetails = this.onGetDetails.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
  }

  // componentDidMount() {
  //   this.onGetDetails();
  // }

  async onGetDetails() {
    const { handleGetCashJournal, match } = this.props;
    const { id } = match.params;
    try {
      const payload = await handleGetCashJournal({ id });
      this.setState({
        journal: payload,
      });
    } catch (err) {
      // err action
    }
  }

  _onFormChange(event) {
    const { onChange } = this.props;
    onChange(event);
  }


  render() {
    const { journal } = this.state;
    return (

      <div className="laporan-ki4__header-content">

        {/* <Button
          title="Cetak Ke Printer"
          onClick={() => {
            onClickPrint('detail-cash-journal__header',
              'detail-cash-journal__table',
              'detail-cash-journal__footer');
          }}
        /> */}
        <div id="divPrint" style={{ width: 810, border: '0px solid black' }}>
          <div>
            <div className="laporan-ki4__content">
              <div className="laporan-ki4__header">
                <div className="laporan-ki4__custom-form-row-square">
                  <div className="laporan-ki4__box--square2">
                    Image
                  </div>
                  <div className="laporan-ki4__header-title">
                    <div className="laporan-ki4__header-title--column">
                      {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                      LAPORAN HASIL BELAJAR SISWA
                    </div>
                    <div className="laporan-ki4__header-title--column">
                      {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                      SEKOLAH MENENGAH PERTAMA
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="laporan-ki4__header-title3">
              <div className="laporan-ki4__header-title3--left">
                <table className="laporan-ki4__table-test">
                  <tr>
                    <td />
                    <td>Nama Siswa </td>
                    <td>  : Gange</td>
                  </tr>
                  <tr>
                    <td />
                    <td>Nomor Induk </td>
                    <td>  : SMP Katolik Ricci</td>

                  </tr>
                  <tr>
                    <td />
                    <td>No.ID.Reg</td>
                    <td>  : SMP Katolik Ricci</td>

                  </tr>
                  <tr>
                    <td />
                    <td>Nama Sekolah</td>
                    <td>  : SMP Katolik Ricci</td>

                  </tr>
                  <tr>
                    <td />
                    <td>Alamat Sekolah</td>
                    <td>  : SMP Katolik Ricci</td>

                  </tr>

                </table>
              </div>

              <div className="laporan-ki4__header-title3--right">
                <table className="laporan-ki4__table-test">
                  <tr>
                    <td />
                    <td>Tahun Ajaran </td>
                    <td>  : SMP Katolik Ricci</td>
                  </tr>
                  <tr>
                    <td />
                    <td>Periode</td>
                    <td>  : SMP Katolik Ricci</td>

                  </tr>
                  <tr>
                    <td />
                    <td>Kelas / No.Absen</td>
                    <td>  : SMP Katolik Ricci</td>

                  </tr>
                </table>
              </div>
            </div>

            <div className="laporan-ki4__header-title-table">
              A. Sikap
            </div>

            <div className="laporan-ki4__body">
              <table className="laporan-ki4__table">
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>INDIKATOR</th>
                    <th>NILAI</th>
                    <th>CATATAN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>NAMA MATA PELAJARAN</td>
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="laporan-ki4__header-title-table">
              B. Pengetahuan
            </div>

            <div className="laporan-ki4__body">
              <table className="laporan-ki4__table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Mata Pelajaran</th>
                    <th>KBM</th>
                    <th>Nilai</th>
                    <th>Predikat</th>
                    <th>Deskripsi Pengetahuan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>NAMA MATA PELAJARAN</td>
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="laporan-ki4__header-title-table">
              C. Keterampilan
            </div>

            <div className="laporan-ki4__body">
              <table className="laporan-ki4__table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Mata Pelajaran</th>
                    <th>KBM</th>
                    <th>Nilai</th>
                    <th>Predikat</th>
                    <th>Deskripsi Pengetahuan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>NAMA MATA PELAJARAN</td>
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="laporan-ki4__header-title2">
              <div className="laporan-ki4__header-title2--column">
                <div className="laporan-ki4__header-title2--bold">
                  Kesimpulan
                </div>

                <div className="laporan-ki4__header-title2--row">
                  <div className="laporan-ki4__header-title2--row">
                    Dinyatakan &nbsp;
                  </div>
                  <div className="laporan-ki4__header-title2--bold">
                    NAIK/TIDAK NAIK
                  </div>
                  <div className="laporan-ki4__header-title2--row">
                                    &nbsp;ke kelas VII / Program Studi:Ilmu Alam atau Ilmu Sosial atau Ilmu Bahasa
                  </div>
                </div>
              </div>
            </div>

            <div className="laporan-ki4__custom-form-row">
              <div className="laporan-ki4__custom-form-row__field">

                <div className="laporan-ki4__custom-form-column">
                  <p>Mengetahui</p>
                  <div className="laporan-ki4__custom-form-column">
                    <p>Orang Tua Wali</p>
                  </div>
                  <div className="laporan-ki4__custom-form-column__field">
                    <p>.....................................</p>
                  </div>
                </div>

                <div className="laporan-ki4__custom-form-column3">
                  <p>Jakarta,</p>
                  <div className="laporan-ki4__custom-form-column">
                    <p>Wali Kelas</p>
                  </div>
                  <div className="laporan-ki4__custom-form-column3__field2">
                    <p>(&emsp; &emsp; &emsp; &emsp; &emsp;)</p>
                  </div>
                </div>


              </div>
            </div>


          </div>
        </div>
      </div>
    );
  }
}
export default class RaportNarasi extends Component {
  constructor(props) {
    super(props);

    this.state = {
      journal: {},
    };
  }


  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="box">

                <div className="divContainter">
                  <div>
                    <ReactToPrint
                      trigger={() => <Button style={{ marginBottom: 10 }} block>Print</Button>}
                      content={() => this.componentRef}
                    />
                    <ComponentToPrint ref={el => (this.componentRef = el)} />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    );
  }
}
RaportNarasi.propTypes = {
  handleGetCashJournal: PropTypes.func,
  match: PropTypes.object.isRequired,
};
RaportNarasi.defaultProps = {
  handleGetCashJournal: noop,
};
